import { Component, OnDestroy, OnInit } from '@angular/core'
import { MenuSettingSelectorLevel1, MenuSettingStore } from '@cms/store/MenuSetting'
@Component({
  selector: 'ket-display-menu',
  templateUrl: './display-menu.component.html',
  styleUrls: ['./display-menu.component.scss'],
})
export class KetDisplayMenuComponent implements OnInit, OnDestroy {
  constructor() {}

  data = MenuSettingStore.get().changing.setting[MenuSettingSelectorLevel1.get().page_id]
  MenuSettingStore = MenuSettingStore

  unsubscribe: (() => void)[] = []

  ngOnDestroy(): void {
    this.unsubscribe.forEach((unsubscribe) => {
      unsubscribe()
    })
  }

  ngOnInit(): void {
    this.unsubscribe.push(
      MenuSettingSelectorLevel1.subscribe((res) => {
        if (!res) return
        this.data = MenuSettingStore.get().changing.setting[res.page_id]
        console.log('MenuSettingSelectorLevel1', this.data)
      }),
    )
  }

  changeType() {
    MenuSettingStore.set({
      running: MenuSettingStore.get().changing,
      changing: {
        ...MenuSettingStore.get().changing,
        setting: {
          ...MenuSettingStore.get().changing.setting,
          [MenuSettingSelectorLevel1.get().page_id]: this.data,
        },
      },
    })
  }
}
